import {
    AnimationBaseController,
    GameRandom,
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameLogic } from "../../../Logic/GameLogic";
import { OutfitNamesConstants } from "../../../Constants/OutfitNamesConstants";
import { OutfitCollisionModel } from "../../../Models/BgContainerModels/CollisionSubjectModel/OutfitCollisionModel";
import { AnimationContents } from "../../AnimationContents";
import { Debug } from "../../../Utils/Debug";
import { DbLightController } from "./DbLightController";
import { OutfitInnerController } from "./OutfitInnerController";
import { SpineAnimationBaseController } from "../../Spine/SpineAnimationBaseController";
import { SoundConstants, SoundLevels } from "../../../Constants/SoundConstants";

export interface IOutfitControllerOptions {
}

export class OutfitController extends AnimationBaseController {
    $model: OutfitCollisionModel;
    private _spineAnimationController: SpineAnimationBaseController;

    public constructor(@Inject private _options: IOutfitControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("OutfitController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.MAIN_SCREEN_JSON,
            libraryName: "outfit",
            childControllers: {
                Light: {
                    controller: OutfitInnerController,
                    model: this.$model,
                    instanceName: 'outfit_inner'
                },
                animation: {
                    controller: SpineAnimationBaseController,
                    model: this.$model,
                    options: {
                        key: 'icons_bg_json',
                        url: '/images/spine/icons/icons_bg.json',
                        animations: [
                            'icon_1',
                            'icon_2',
                            'icon_3',
                            'icon_4',
                            'icon_5',
                            'icon_6',
                            'icon_7'
                        ]
                    }
                },
                animation_bonus: {
                    controller: SpineAnimationBaseController,
                    model: this.$model,
                    options: {
                        key: 'bonus_icon_json',
                        url: '/images/spine/icons/bonus_icon.json',
                        animations: [
                            'bonus_end_part_1',
                            'bonus_end_part_2',
                            'bonus_end_part_3',
                            'bonus_part_1_loop',
                            'bonus_part_2_loop',
                            'bonus_part_3_loop',
                        ]
                    }
                }
            },
            modelWatch: {
                "pos.x": (x: number) => {
                    this.x = Math.round(x);
                },
                "isActive": (isActive: boolean) => {
                    this.visible = isActive;
                    Debug.drawAABB(this, this.$model);
                },
                "name": (name: OutfitNamesConstants) => {
                    this.gotoAndStop(name);
                },
                "outfitName": (outfitName: number) => {
                    this.gotoAndStopByQuery("outfit_inner", outfitName);
                    Debug.drawAABB(this, this.$model);
                },
                "billboardName": (billboardName: number) => {
                    this.gotoAndStopByQuery("billboard", billboardName);
                },
                "isCollected": (isCollected: boolean) => {
                    if (isCollected) {
                        if (this.visible) {
                            if (this.$model.outfitName === 7) {
                                this._gameLogic.addBonus();
                            }
                            this._gameLogic.addOutFitCollect(this.$model.outfitName);
                            this.soundManager.playSound(SoundConstants.CROWD_1, 0, SoundLevels.crowdSound);
                            this.visible = false;
                        }

                    }

                },
            }
        };
    }

    protected onInitialize(): void {
        const { x, y } = this.$model.pos;
        this.x = Math.round(x);
        this.y = Math.round(y);
        this.visible = this.$model.isActive;
        this.gotoAndStop(this.$model.name);
        this.gotoAndStopByQuery("outfit_inner", this.$model.outfitName);
        this.getDisplayObjectByQuery('outfit_inner')[0].visible = false;

        if (this.$model.outfitName < 7) {
            this._spineAnimationController = this.$childControllers.get('animation');
            this._spineAnimationController.setAnimation(`icon_${this.$model.outfitName + 1}`, true);
        } else {

            this._spineAnimationController = this.$childControllers.get('animation_bonus');
            this._spineAnimationController.setAnimation(`bonus_part_${this._gameLogic.getBonusCount() + 1}_loop`, true);
        }

        this._spineAnimationController.x = 50;
        this._spineAnimationController.y = this.getDisplayObjectByQuery('outfit_inner')[0].y - 50;
        this._spineAnimationController.scaleX = 0.6;
        this._spineAnimationController.scaleY = 0.6;


        Debug.drawAABB(this, this.$model);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
}

